import { z } from "zod";

import { OutputId } from "../../idTypeBrands.js";
import { createAppSessionEventDefinition } from "../AppSessionEventDefinition.js";
import { OutputContent } from "../AppSessionEventState.js";

import { zUnattachedOutputContent } from "./zUnattachedOutputContent.js";

export const REPLACE_OUTPUT_CONTENTS = createAppSessionEventDefinition({
  type: "REPLACE_OUTPUT_CONTENTS",
  payloadSchema: z.object({
    outputId: OutputId,
    outputContents: z.array(zUnattachedOutputContent),
  }),
  logSafe: { outputId: true, outputContents: false },
  create: (payload: {
    outputId: OutputId;
    outputContents: Omit<OutputContent, "outputId">[];
  }) => payload,
  apply: ({ indices, payload: { outputContents, outputId }, state }) => {
    const warnings: string[] = [];

    if (state.outputs[outputId] == null) {
      warnings.push(`Output not found: ${outputId}`);
    }

    const prevOutputContentIds = indices.outputIdToOutputContentIds[outputId];

    if (prevOutputContentIds == null) {
      warnings.push(`Output content index for output not found: ${outputId}`);
    }

    for (const prevOutputContentId of prevOutputContentIds ?? []) {
      delete state.outputContents[prevOutputContentId];
    }

    for (const outputContent of outputContents) {
      state.outputContents[outputContent.id] = {
        ...outputContent,
        outputId,
      };
    }

    indices.outputIdToOutputContentIds[outputId] = outputContents.map(
      (c) => c.id,
    );

    return { warnings };
  },
});
